module.exports = __webpack_public_path__ + "static/media/home_active.4ba0df3c.png";